import { apiClient } from "@lib/axios";
import type { IStoriesFolder, IStoriesFolderUser } from "@/shared/types";

export interface ICreateFolderParams {
  name: string;
  users: IStoriesFolderUser[];
  openAccess: boolean;
  parentId?: string | null;
}

export interface IUpdateFolderParams {
  id: string;
  name?: string;
  openAccess?: boolean;
  users?: IStoriesFolderUser[];
  parentId?: string | null;
}

export interface IDeleteFolderParams {
  id: string;
}

export interface IReorderFoldersParams {
  folderIds: string[];
}

export const foldersApi = {
  getFolders: () => {
    return apiClient.get<IStoriesFolder[]>("/folders");
  },

  getFolderById: (id: string) => {
    return apiClient.get<IStoriesFolder>(`/folders/${id}`);
  },

  createFolder: (data: ICreateFolderParams) => {
    return apiClient.post<IStoriesFolder>("/folders", data);
  },

  updateFolder: (data: IUpdateFolderParams) => {
    const { id, ...updateData } = data;
    return apiClient.put<IStoriesFolder>(`/folders/${id}`, updateData);
  },

  deleteFolder: (id: string) => {
    return apiClient.delete<IStoriesFolder>(`/folders/${id}`);
  },

  reorderFolders: (folderIds: string[]) => {
    return apiClient.put<void>("/folders/reorder", {
      folderIds,
    });
  },
};
